var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0 0.160156)",
    fill: "#185CE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 24.6602V22.0851C14 21.3446 14.1416 20.5746 14.4249 19.7752C14.7167 18.9673 15.1116 18.2057 15.6094 17.4905C16.1159 16.7667 16.6824 16.1567 17.309 15.6602L19.4721 17.036C18.9657 17.785 18.5408 18.5676 18.1974 19.3839C17.8627 20.1917 17.6996 21.0837 17.7081 22.0599V24.6602H14ZM20.5279 24.6602V22.0851C20.5279 21.3446 20.6695 20.5746 20.9528 19.7752C21.2446 18.9673 21.6395 18.2057 22.1373 17.4905C22.6438 16.7667 23.2103 16.1567 23.8369 15.6602L26 17.036C25.4936 17.785 25.0687 18.5676 24.7253 19.3839C24.3906 20.1917 24.2275 21.0837 24.2361 22.0599V24.6602H20.5279Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    fill: "white",
    transform: "translate(14 15.6602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.001ff4b314ca3d089a01a63809993bdf.svg";
export { ForwardRef as ReactComponent };